var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"category-pill"},[_c('span',[_vm._t("category-name")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }